import { HttpService } from "../../modules/shared/services/http.service";
import { 
  RefundRequest, 
  RefundRequestCreateDto, 
  RefundRequestUpdateDto,
  RefundRequestResponse,
  RefundRequestLatestResponse
} from "../../modules/shared/model/refund-request.interfaces";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Get all refund requests with pagination
export const getRefundRequests = async (query?: Record<string, string | number | boolean | object>): Promise<RefundRequestResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) {
      // Handle filters object separately
      if (k === "filters" && typeof v === "object") {
        qs.append(k, JSON.stringify(v));
      } else {
        qs.append(k, String(v));
      }
    }
  });
  const response = await HttpService.get(`api/v1/refund-requests${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get refund requests by user
export const getRefundRequestsByUser = async (userId: string, query?: Record<string, string | number | boolean | object>): Promise<RefundRequestResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) {
      // Handle filters object separately
      if (k === "filters" && typeof v === "object") {
        qs.append(k, JSON.stringify(v));
      } else {
        qs.append(k, String(v));
      }
    }
  });
  const response = await HttpService.get(`api/v1/refund-requests/user/${userId}${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get refund request by ID
export const getRefundRequestById = async (id: string): Promise<RefundRequest> => {
  const response = await HttpService.get(`api/v1/refund-requests/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

// Create new refund request
export const createRefundRequestAction = async (data: RefundRequestCreateDto): Promise<RefundRequest> => {
  const response = await HttpService.post("api/v1/refund-requests", data, headers, true);
  return response;
};

// Update refund request
export const updateRefundRequestAction = async (id: string, data: RefundRequestUpdateDto): Promise<RefundRequest> => {
  const response = await HttpService.patch(`api/v1/refund-requests/${id}`, data, headers, true);
  return response;
};

// Delete refund request
export const deleteRefundRequestAction = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/refund-requests/${id}`, { "x-custom-lang": "en" }, true);
};

// Bulk create refund requests
export const bulkCreateRefundRequestsAction = async (refundRequests: RefundRequestCreateDto[]): Promise<RefundRequest[]> => {
  const response = await HttpService.post("api/v1/refund-requests/bulk", { refundRequests }, headers, true);
  return response;
};

// Bulk update refund requests
export const bulkUpdateRefundRequestsAction = async (refundRequests: Array<{ id: string; data: RefundRequestUpdateDto }>): Promise<RefundRequest[]> => {
  const response = await HttpService.patch("api/v1/refund-requests/bulk", { refundRequests }, headers, true);
  return response;
};

// Get refund requests by contract ID
export const getRefundRequestsByContract = async (contractId: string, query?: Record<string, string | number | boolean | object>): Promise<RefundRequestResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) {
      // Handle filters object separately
      if (k === "filters" && typeof v === "object") {
        qs.append(k, JSON.stringify(v));
      } else {
        qs.append(k, String(v));
      }
    }
  });
  const response = await HttpService.get(`api/v1/refund-requests/contract/${contractId}${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};
